import { IItemWishList } from "src/app/shared/interfaces/custom-item-wish-list";
import { CustomProductCardEnt } from "src/app/shared/interfaces/custom-product-card-ent";
import { IOrderData } from "src/app/shared/interfaces/order.interface";

export class WishList{

  listWish: IItemWishList[] = [];

  getListWishFromStore(){
    if (localStorage.getItem('myWishList') !== null) {
      const jsonString = localStorage.getItem('myWishList');

      if (jsonString) {
        this.listWish = JSON.parse(jsonString);
      }
    }
  }

  addItemWishList(product: CustomProductCardEnt, cant: number, stock: number =  Number.MAX_SAFE_INTEGER): void{
    this.getListWishFromStore();

    let existingItem = this.listWish.find(item => item.idProduct === product.id  && item.product.colorId === product.colorId && item.product.measurementSystemDetailId === product.measurementSystemDetailId );

    if (existingItem) {
      existingItem.cant = Math.min(parseFloat(existingItem.cant.toString())  + parseFloat(cant.toString()), stock);
    } else {
      const newItem: IItemWishList = {
        idProduct: product.id,
        product: product,
        cant: cant,
        size: product.measurementSystemDetailValue
      };
      this.listWish.push(newItem);
    }

    localStorage.setItem('myWishList', JSON.stringify(this.listWish));
  }

  updateItemWishList(product: CustomProductCardEnt, cant: number){
    this.getListWishFromStore();

    if(cant <= 0){
        this.deleteItem(product);
    } else {
      const existingItem = this.listWish.find(item => item.idProduct === product.id  && item.product.colorId === product.colorId && item.product.measurementSystemDetailId === product.measurementSystemDetailId);

      if (existingItem) {
          existingItem.cant = parseFloat(cant.toString());
      } else {
        const newItem: IItemWishList = {
          idProduct: product.id,
          product: product,
          cant: cant,
        };
        this.listWish.push(newItem);
      }

      localStorage.setItem('myWishList', JSON.stringify(this.listWish));
    }
  }

  deleteItem(product: CustomProductCardEnt){
    const index = this.listWish.findIndex(item => item.idProduct === product.id  && item.product.colorId === product.colorId && item.product.measurementSystemDetailId === product.measurementSystemDetailId);
    this.listWish.splice(index, 1);
    localStorage.setItem('myWishList', JSON.stringify(this.listWish));
  }

  getItemWishList(product: CustomProductCardEnt){
    this.getListWishFromStore();

    const existingItem = this.listWish.find(item => item.idProduct === product.id  && item.product.colorId === product.colorId && item.product.measurementSystemDetailId === product.measurementSystemDetailId);

    if (existingItem) {
      return existingItem;
    } else {
      const newItem = new IItemWishList ();
      return newItem;
    }
  }

  countForItems(){
    this.getListWishFromStore();
    let totalCant = 0;
    for (const item of this.listWish) {
        totalCant += item.cant;
    }

    return totalCant;
  }

  totPriceWishList() {
    this.getListWishFromStore();
    let totalPrice = 0;
    for (const item of this.listWish) {
      const price = item.product.isOnDiscount
          ? item.product.priceDiscount
          : item.product.price;

      totalPrice += (parseFloat(price.toString()) * parseFloat(item.cant.toString()));
    }

    return totalPrice;
  }

  getList(){
    this.getListWishFromStore();
    return this.listWish;
  }

  getOrderArray(address?: string, city?: string){
    this.getListWishFromStore();
    const client = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : '';
    let orderArray: IOrderData = {};
    orderArray.clientId = client.id === undefined ? '' : client.id;
    orderArray.clientEmail = client.email === undefined ? '' : client.email;
    orderArray.clientPhone = client.phone === undefined ? '' : client.phone;
    orderArray.clientAddress = address ? address : client.address;
    orderArray.clientCity = city ? city : client.city;
    orderArray.orderDatail = [];



    this.listWish.forEach(element => {
      orderArray.orderDatail!.push(
        {
          productId: element.idProduct === undefined ? '':element.idProduct,
          measurementSystemDetailId: element.product.measurementSystemDetailId === undefined ? '':element.product.measurementSystemDetailId,
          colorId: element.product.colorId === undefined ? '': element.product.colorId,
          quantity: element.cant,
          productName: element.product.productName === undefined ? '' : element.product.productName,
          productImage: element.product.image === undefined ? '' : element.product.image,
          productSize: element.size === undefined ? '' : element.size
        }
      );
    });

    return orderArray;
  }

  deleteList(){
    this.getListWishFromStore();
    this.listWish = [];
    localStorage.setItem('myWishList', JSON.stringify(this.listWish));
  }
}
